/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Cancel = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <rect
                        x="4.5459"
                        y="3.48529"
                        width="22.5611"
                        height="1.5"
                        transform="rotate(45 4.5459 3.48529)"
                        fill={color}
                    />
                    <rect
                        x="3.48535"
                        y="19.4384"
                        width="22.5611"
                        height="1.5"
                        transform="rotate(-45 3.48535 19.4384)"
                        fill={color}
                    />
                </svg>
        );
    };
